import { render, staticRenderFns } from "./AccountForm.vue?vue&type=template&id=05b54d82&scoped=true"
import script from "./AccountForm.vue?vue&type=script&lang=js"
export * from "./AccountForm.vue?vue&type=script&lang=js"
import style0 from "./AccountForm.vue?vue&type=style&index=0&id=05b54d82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b54d82",
  null
  
)

export default component.exports